(function () {
  "use strict";

  var theme = window.theme || {};
  var routes = theme.routes || { cart_add: "/cart/add", cart_change: "/cart/change", cart: "/cart" };

  /* ---------- Money formatting (Shopify standard) ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || theme.moneyFormat || "${{amount}}";

    function defaultTo(num, precision, thousands, decimal) {
      precision = isNaN(precision) ? 2 : precision;
      thousands = thousands === undefined ? "," : thousands;
      decimal = decimal === undefined ? "." : decimal;
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount": value = defaultTo(cents, 2); break;
      case "amount_no_decimals": value = defaultTo(cents, 0); break;
      case "amount_with_comma_separator": value = defaultTo(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = defaultTo(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = defaultTo(cents, 2, " ", ","); break;
      case "amount_no_decimals_with_space_separator": value = defaultTo(cents, 0, " ", ""); break;
      default: value = defaultTo(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Header scroll state ---------- */
  function initHeader() {
    var header = qs("[data-header]");
    if (!header) return;
    function onScroll() {
      if (window.scrollY > 20) header.classList.add("is-scrolled");
      else header.classList.remove("is-scrolled");
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  function initMobileMenu() {
    var menu = qs("[data-mobile-menu]");
    var open = qs("[data-menu-open]");
    var close = qs("[data-menu-close]");
    if (!menu) return;
    if (open) open.addEventListener("click", function () { menu.classList.add("is-open"); });
    if (close) close.addEventListener("click", function () { menu.classList.remove("is-open"); });
  }

  /* ---------- Cart drawer ---------- */
  var drawer, overlay, body, foot, countEls;

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function setCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute("hidden");
      else el.setAttribute("hidden", "");
    });
  }

  function svg(name) {
    var icons = {
      minus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      plus: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>',
      trash: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>',
      dog: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 5.172C10 3.782 8.423 2.679 6.5 3.214 4.683 3.72 3.5 5.04 3.5 6.5c0 1.318 1.116 2.5 2.5 2.5h.879"/><path d="M14 5.172C14 3.782 15.577 2.679 17.5 3.214c1.817.506 3 1.826 3 3.286 0 1.318-1.116 2.5-2.5 2.5h-.879"/><path d="M8 14v.5M16 14v.5M11.25 16.25h1.5L12 17l-.75-.75z"/><path d="M4.42 11.247A13.152 13.152 0 0 0 4 14.556C4 18.728 7.582 21 12 21s8-2.272 8-6.444c0-1.061-.162-2.2-.493-3.309"/></svg>',
      arrow: '<svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>'
    };
    return icons[name] || "";
  }

  function renderCart(cart) {
    if (!body) return;
    setCount(cart.item_count);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="cart-empty">' +
        '<div class="blob">' + svg("dog") + '</div>' +
        '<div><h3>It\'s a little empty here.</h3>' +
        '<p>Looks like your furry friend is waiting for some treats.</p></div>' +
        '<button class="btn btn-primary btn-block btn-lg" data-cart-close>Start Spoiling Them</button>' +
        '</div>';
      if (foot) foot.setAttribute("hidden", "");
      bindBodyEvents();
      return;
    }

    var html = '<div class="cart-lines">';
    cart.items.forEach(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]*)$/, "_200x$1") + '" alt="' + escapeHtml(item.product_title) + '">'
        : "";
      var variant =
        item.variant_title && item.variant_title !== "Default Title"
          ? '<p class="variant">' + escapeHtml(item.variant_title) + "</p>"
          : "";
      html +=
        '<div class="cart-line" data-key="' + item.key + '">' +
        '<div class="thumb">' + img + "</div>" +
        '<div class="detail">' +
        '<div class="top"><div>' +
        "<h4>" + escapeHtml(item.product_title) + "</h4>" +
        variant +
        "</div>" +
        '<button class="remove" data-remove="' + item.key + '" aria-label="Remove">' + svg("trash") + "</button>" +
        "</div>" +
        '<div class="bottom">' +
        '<div class="qty">' +
        '<button data-change="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">' + svg("minus") + "</button>" +
        '<span class="val">' + item.quantity + "</span>" +
        '<button data-change="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">' + svg("plus") + "</button>" +
        "</div>" +
        '<span class="line-price">' + formatMoney(item.final_line_price) + "</span>" +
        "</div></div></div>";
    });
    html += "</div>";
    body.innerHTML = html;

    if (foot) {
      foot.removeAttribute("hidden");
      qs("[data-cart-total]", foot).textContent = formatMoney(cart.total_price);
    }
    bindBodyEvents();
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : str;
    return div.innerHTML;
  }

  function bindBodyEvents() {
    qsa("[data-cart-close]").forEach(function (b) {
      b.addEventListener("click", closeDrawer);
    });
    qsa("[data-change]", body).forEach(function (b) {
      b.addEventListener("click", function () {
        changeLine(b.getAttribute("data-change"), parseInt(b.getAttribute("data-qty"), 10));
      });
    });
    qsa("[data-remove]", body).forEach(function (b) {
      b.addEventListener("click", function () {
        changeLine(b.getAttribute("data-remove"), 0);
      });
    });
  }

  function fetchCart() {
    return fetch(routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(renderCart);
  }

  function changeLine(key, quantity) {
    body.classList.add("is-loading");
    fetch(routes.cart_change + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); body.classList.remove("is-loading"); })
      .catch(function () { body.classList.remove("is-loading"); });
  }

  function addToCart(form, button) {
    var formData = new FormData(form);
    if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = "Adding..."; }
    fetch(routes.cart_add + ".js", {
      method: "POST",
      headers: { Accept: "application/javascript" },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () {
        openDrawer();
        if (button) { button.disabled = false; button.textContent = button.dataset.label || "Add to Cart"; }
      })
      .catch(function () {
        if (button) { button.disabled = false; button.textContent = button.dataset.label || "Add to Cart"; }
      });
  }

  function initCart() {
    drawer = qs("[data-cart-drawer]");
    overlay = qs("[data-cart-overlay]");
    body = qs("[data-cart-body]");
    foot = qs("[data-cart-foot]");
    countEls = qsa("[data-cart-count]");
    if (!drawer) return;

    qsa("[data-cart-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); refreshCart().then(openDrawer); });
    });
    if (overlay) overlay.addEventListener("click", closeDrawer);
    qsa("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeDrawer); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

    qsa("[data-product-form]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        addToCart(form, qs("[data-add-button]", form));
      });
    });

    refreshCart();
  }

  /* ---------- PDP gallery ---------- */
  function initGallery() {
    var main = qs("[data-gallery-main]");
    if (!main) return;
    qsa("[data-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var src = thumb.getAttribute("data-src");
        main.src = src;
        qsa("[data-gallery-thumb]").forEach(function (t) { t.classList.remove("active"); });
        thumb.classList.add("active");
      });
    });
  }

  /* ---------- PDP variant selection ---------- */
  function initVariants() {
    var form = qs("[data-product-form]");
    if (!form) return;
    var variantsScript = qs("[data-variants-json]");
    if (!variantsScript) return;
    var variants = JSON.parse(variantsScript.textContent);
    var idInput = qs("[data-variant-id]", form);
    var priceEl = qs("[data-product-price]");
    var addBtn = qs("[data-add-button]", form);

    function currentOptions() {
      return qsa("[data-option-index]", form)
        .filter(function (i) { return i.checked; })
        .sort(function (a, b) {
          return a.getAttribute("data-option-index") - b.getAttribute("data-option-index");
        })
        .map(function (i) { return i.value; });
    }

    function update() {
      var selected = currentOptions();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === selected[idx]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      if (addBtn) {
        if (match.available) { addBtn.disabled = false; addBtn.textContent = "Add to Cart"; }
        else { addBtn.disabled = true; addBtn.textContent = "Sold Out"; }
      }
    }

    qsa("[data-option-index]", form).forEach(function (input) {
      input.addEventListener("change", update);
    });
    update();
  }

  /* ---------- Scroll reveal ---------- */
  function initReveal() {
    var els = qsa(".reveal");
    if (!("IntersectionObserver" in window) || els.length === 0) {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  function init() {
    initHeader();
    initMobileMenu();
    initCart();
    initGallery();
    initVariants();
    initReveal();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
